import React from 'react';
import {BreadcrumbItem, DashboardHeader} from '../dashboard-header';
import {DashboardSidebar} from '../dashboard-sidebar';

interface DashboardLayoutProps {
  breadcrumbs?: BreadcrumbItem[];
  children: React.ReactNode;
  className?: string;
  contentPaddingClassName?: string;
  headerActions?: React.ReactNode;
  hideHeader?: boolean;
  hideSidebar?: boolean;
  sidebarOffsetClassName?: string;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  breadcrumbs,
  children,
  className = 'bg-gray-50',
  contentPaddingClassName = 'px-8',
  headerActions,
  hideHeader = false,
  hideSidebar = false,
  sidebarOffsetClassName,
}) => {
  const computedSidebarOffset = sidebarOffsetClassName !== undefined ? sidebarOffsetClassName : hideSidebar ? 'ml-0' : 'ml-20';

  return (
    <div className={`flex h-screen flex-col overflow-hidden ${className}`}>
      {!hideSidebar && <DashboardSidebar />}
      {!hideHeader && <DashboardHeader actions={headerActions} breadcrumbs={breadcrumbs} />}
      <div className={`${computedSidebarOffset} flex flex-1 flex-col overflow-hidden`}>
        <main className={`flex-1 overflow-y-auto ${contentPaddingClassName}`}>{children}</main>
      </div>
    </div>
  );
};
